import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-pricing-works',
  templateUrl: './how-pricing-works.component.html',
  styleUrls: ['./how-pricing-works.component.scss']
})
export class HowPricingWorksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
